import axios from 'axios';

export function mensagemErroAtualizacaoUrlPublica(error: unknown, t: (key: string) => string) {
  if (!axios.isAxiosError(error)) return t('checklists.publicAccess.urlUpdateUnexpectedError');

  switch (error.response?.status) {
    case 400:
      return t('checklists.publicAccess.urlUpdateInvalidAliases');
    case 403:
      return t('checklists.publicAccess.urlUpdatePermissionDenied');
    case 404:
      return t('checklists.publicAccess.urlUpdateChecklistNotFound');
    case 409:
      return t('checklists.publicAccess.urlUpdateAliasInUse');
    default:
      return t('checklists.publicAccess.urlUpdateUnexpectedError');
  }
}
